import { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import FindUserClass from './FindUser';
import LearningContext from '_helper/Leatning';

const UserFilter = () => {
  const { isOpen, setIsOpen } = useContext(LearningContext);
  const onClickeHandel = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Col xl="3 xl-20">
      <div className="job-sidebar md-sidebar"><a className="btn btn-primary md-sidebar-toggle" href="#javascript" onClick={onClickeHandel}>Filter User</a>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? 'open' : ''}`}>
          <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <Row>
              <FindUserClass />
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default UserFilter;